import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { BaseBackend } from '@shared/apis/servers/base-backend';

@Injectable({
  providedIn: 'root'
})
export class SalesDataBackendServer extends BaseBackend {
  getSalesDataList(builder): Observable<any> {
    return this.get('/sales-data', { params: builder });
  }

  deleteAllSalesData(): Observable<any> {
    return this.delete('/sales-data/delete/all');
  }

  deleteSalesData(productType, year, month): Observable<any> {
    return this.delete(`/sales-data/${ productType }/${ year }/${ month }`);
  }
}
